import React from "react";
import { useT } from "@/i18n/LanguageContext";

// "What makes X special" grid + "Available in" variant chips.
export default function BrandHighlights({ brand, highlights, variants }) {
  const { t } = useT();
  return (
    <section className="bg-white border-b border-neutral-100">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <p className="overline" style={{ color: brand.palette.accent }}>
            {t("brandPage.whatMakes")}
          </p>
          <h2 className="mt-4 font-display font-black text-3xl md:text-4xl text-[#001F39] leading-tight">
            {t("brandPage.closerLook")} {brand.name}.
          </h2>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
          {highlights.map((h) => (
            <div
              key={h}
              className="p-5 rounded-2xl text-sm md:text-base leading-snug text-neutral-700 bg-neutral-50 border border-neutral-200"
            >
              {h}
            </div>
          ))}
        </div>
      </div>
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pb-16">
        <p className="overline text-neutral-500 mb-4">{t("brandPage.availableIn")}</p>
        <div className="flex flex-wrap gap-2">
          {variants.map((v) => (
            <span
              key={v}
              className="px-4 py-1.5 rounded-full text-sm font-medium"
              style={{
                background: `${brand.palette.accent}12`,
                color: brand.palette.accent,
                border: `1px solid ${brand.palette.accent}30`,
              }}
            >
              {v}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
